import { BreachPathAppController } from '../controller/BreachPathAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class BreachPathAppWebComponent extends BaseWebComponentElement {
  public breachPathIssueId: string;
  
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: BreachPathAppController,
    });
  }
}
